import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

import {
    quotesMenuMixin
} from './vue/mixins/quotes';
import QuoteSearch from './vue/components/quote-search/QuoteSearch.vue';

const mixins = [];
mixins.push(quotesMenuMixin);
initMain(mixins, {
    QuoteSearch,
    QuoteGraph: () => import('./vue/components/quote-graph/QuoteGraph.vue'),
    QuoteBarGraph: () => import('./vue/components/quote-bar-graph/QuoteBarGraph.vue'),
    RecentQuotes: () => import('./vue/components/recent-quotes/RecentQuotes.vue')
}, []);
header();